import { AgChartProps, AgCharts } from "ag-charts-react";
import { theme } from "./theme";
import { AgChartOptions } from "ag-charts-community";
import hydrateSeriesStyles from "./hydrateSeriesStyles";
import _ from "lodash";
import { ChartContainer } from "./ChartContainer";
import { Series } from "./Chart.types";
import { OptionRawSelect } from "../Form/RawSelect";
import { DateRange } from "../../../features/Charts/hooks/useDateRangeFilter";

export const Chart = ({
    options,
    title,
    description,
    isCondensed = false,
    isSnapshot = false,
    titleLink,
    periodFilter,
    dateRangeFilter,
    ...rest
}: {
    options: AgChartOptions;
    title: string;
    description: string;
    isCondensed?: boolean;
    isSnapshot?: boolean;
    titleLink?: {
        label: string;
        href?: string;
        onClick?: () => void;
    };
    periodFilter?: {
        selectedPeriod: OptionRawSelect;
        onPeriodChange: (option: OptionRawSelect | OptionRawSelect[]) => void;
        options?: OptionRawSelect[];
    };
    dateRangeFilter?: {
        dateRange: DateRange;
        onDateRangeChange: (range: DateRange) => void;
        availableDates: string[];
    };
} & AgChartProps) => {
    const series: Series = hydrateSeriesStyles(options.series as Series);

    return (
        <ChartContainer
            title={title}
            description={description}
            isCondensed={isCondensed}
            isSnapshot={isSnapshot}
            titleLink={titleLink}
            periodFilter={periodFilter}
            dateRangeFilter={dateRangeFilter}
        >
            {({ height }) => (
                <AgCharts
                    options={_.merge(
                        {
                            theme,
                            padding: {
                                top: 12,
                                right: 4,
                                bottom: 12,
                                left: 4,
                            },
                            legend: {
                                enabled: series && series.length > 1,
                                toggleSeries: true,
                                preventHidingAll: true,
                                position: "bottom",
                            },
                            zoom: {
                                enabled: true,
                                enableSelecting: true,
                                enableScrolling: false,
                                enableDoubleClickToReset: true,
                                axes: "xy",
                                panKey: "shift",
                            },
                            tooltip: {
                                mode: "shared",
                                showArrow: true,
                            },
                            height,
                            annotations: {
                                enabled: true,
                                toolbar: {
                                    enabled: false,
                                },
                            },
                        },
                        { ...options, series: series as any },
                    )}
                    {...rest}
                />
            )}
        </ChartContainer>
    );
};
